export function initFancybox(element) {
    const jquery = window.jQuery;

    if (typeof jquery !== 'function' || !element || !element.length || typeof element.fancybox !== 'function') {
        return;
    }

    if (element.attr('data-fancybox') === undefined) {
        let settings = element.attr('data-fancybox-settings') ? JSON.parse(element.attr('data-fancybox-settings')) : {};
        const captionResolver = function (_instance, current) {
            const trigger = jquery(current.opts.$orig);
            return trigger.attr('data-caption') || '';
        };

        settings.caption = captionResolver;

        settings.afterLoad = function (instance, current) {
            let individualSettings = jquery(current.opts.$orig).attr('data-fancybox-settings') ? JSON.parse(jquery(current.opts.$orig).attr('data-fancybox-settings')) : {};

            if (individualSettings['customClass']) {
                current.$content.addClass(individualSettings['customClass']);
            }

            if (settings.loop) {
                if (current.type === 'video') {
                    let video = current.$content.find('video')[0];
                    if (video) {
                        video.addEventListener('timeupdate', function () {
                            if (video.currentTime >= video.duration - 0.2) {
                                video.currentTime = 0;
                                try {
                                    const playPromise = video.play();
                                    if (playPromise && typeof playPromise.catch === 'function') {
                                        playPromise.catch(function () {});
                                    }
                                } catch (error) {
                                    // A browser may reject playback synchronously.
                                }
                            }
                        });
                    }
                }
            }

            current.$content.find('.fancybox-custom-html').remove();

            if (individualSettings['customHtml']) {
                const wrappedHtml = jquery('<div class="fancybox-custom-html"></div>').html(individualSettings['customHtml']);
                current.$content.append(wrappedHtml);

                document.dispatchEvent(new CustomEvent("growtypeFancyboxShowCustomHtml", {
                    detail: {
                        html: wrappedHtml,
                    },
                }));
            }
        };

        settings.afterShow = function (instance, current) {
            if (settings.muted) {
                if (current.type === 'video') {
                    const videoElement = current.$content.find('video')[0];
                    if (videoElement) {
                        videoElement.muted = true;
                    }
                }
            }
        };

        element.fancybox(settings);
    }
}
